export default __webpack_public_path__ + "static/media/icon_copy.37e97e3f.svg";